import { UnableToStartHalfRedoCheckoutAbTestReason } from "@redotech/redo-model/checkouts/checkout-ab-test-utils";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const canStartHalfRedoCheckoutAbTest = {
  name: "canStartHalfRedoCheckoutAbTest" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.union([
    z.object({ canStart: z.literal(true) }),
    z.object({
      canStart: z.literal(false),
      reason: createEnum(UnableToStartHalfRedoCheckoutAbTestReason),
    }),
  ]),
};
